"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExperimentsService = void 0;
class ExperimentsService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Get experiments
     * @param page 'Page number (default 1)
     * @param count Number of results per page (default 10)
     * @param q Query to filter the results on
     * @returns ExperimentsResponse
     * @throws ApiError
     */
    getExperiments(page, count, q) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/experiments',
            query: {
                'page': page,
                'count': count,
                'q': q,
            },
        });
    }
    /**
     * Create a new experiment.
     * @param requestBody
     * @returns ExperimentResponse
     * @throws ApiError
     */
    createExperiment(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/experiments',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get experiment
     * @param id
     * @returns ExperimentResponse
     * @throws ApiError
     */
    getExperiment(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/experiment/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Update an existing experiment.
     * @param id
     * @param requestBody
     * @returns ExperimentResponse
     * @throws ApiError
     */
    updateExperiment(id, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/experiments/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete an existing experiment.
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    deleteExperiment(id) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/experiments/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Apply feature flags
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    applyFeatureFlags(id) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/experiments/{id}/apply',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Remove feature flags
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    removeFeatureFlags(id) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/experiments/{id}/remove-ff',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Rollout an experiment to a given percentage
     * @param id
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    rollout(id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/experiments/{id}/rollout',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
exports.ExperimentsService = ExperimentsService;
